enum SubscriptionType {
    Document = "Document",
    Query = "Query"
}

export default SubscriptionType;
